import { createContext, useContext } from 'react'

export const SlotContext = createContext<HTMLElement | null>(null)

/** Views call this and portal their controls JSX into the returned element. */
export const useDashboardViewControlsSlot = () => useContext(SlotContext)
